import type { IListItem } from 'types/Contract';

import { useBimWorkOrderObjects } from './useBimWorkOrderObjects';

interface IUseBimWorkOrderObjectsListItems {
    workOrderId?: number;
    rootsOnly?: boolean;
    withEffect?: boolean;
    requestKey?: string;
    rootId?: number;
}

export const useBimWorkOrderObjectsListItems = (props: IUseBimWorkOrderObjectsListItems) => {
    const { workOrderId, rootId, rootsOnly, withEffect = true, requestKey } = props;

    const { reset, data, status, error } = useBimWorkOrderObjects({
        workOrderId,
        rootId,
        rootsOnly,
        requestKey,
        withEffect,
        getKeyValuesOnly: true,
    });

    return {
        reset,
        data: (data?.items?.map((item) => ({
            id: item.id,
            label: item.name,
            parentId: item.parentId,
            workOrderObjectId: item.workOrderObjectId,
        })) || []) as unknown as IListItem<number>[],
        status,
        error,
    };
};
